import * as _4 from 'lodash4';

interface IElement {
  offsetTop: number;
  scrollTo: (x: number, y: number) => void;
}

export class ScrollContentController {
  private id: string;

  $onInit() {
    this.scrollTo();
  }

  $onChanges() {
    this.scrollTo();
  }

  scrollTo() {
    const ele = document.getElementById(this.id) as IElement;
    const yCoord = _4.get(ele, 'offsetTop', undefined);
    if (yCoord) {
      ele.scrollTo(0, yCoord);
    }
  }
}

export class ScrollContentComponent implements angular.IComponentOptions {
  public templateUrl: string = 'capability-ng-appointments/src/components/scroll_content/scroll_content.html';
  public controller: any = ScrollContentController;
  public transclude: boolean = true;
  public bindings: any = {
    id: '@',
    length: '<'
  };
}

angular
  .module('capability-ng-appointments')
  .component('scrollContent', new ScrollContentComponent())
  .controller('ScrollContentController', ScrollContentController);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-appointments/src/components/scroll_content/scroll_content.ts